import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  banner: {
    backgroundColor: theme.palette.primary.main,
    minHeight: '40px',
    paddingBottom: '12px',
  },
  bannerDismissButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  bannerText: {
    color: theme.palette.primary.contrastText,
    fontSize: '14px',
    paddingTop: '8px',
  },
  bannerTextLink: {
    color: 'inherit',
    cursor: 'pointer',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  bannerMessageWrapper: {}
});

class PrivacyBanner extends React.Component {
  render() {
    const brandName = window.globals?.gid?.brand || 'GolfID';

    const dataRightsUrl = window.globals?.gid?.links?.dataRights || '#';
    const privacyPolicyUrl = window.globals?.gid?.links?.privacyPolicy || '#';
    const cookiePolicyUrl = window.globals?.gid?.links?.cookiePolicy || '#';

    const dataRightsLink = <Link color="inherit" href={dataRightsUrl} className={this.props.classes.bannerTextLink} rel="noopener noreferrer" target="_blank">click here.</Link>;
    const privacyPolicyLink = <Link color="inherit" href={privacyPolicyUrl} className={this.props.classes.bannerTextLink} rel="noopener noreferrer" target="_blank">Privacy Policy</Link>;
    const cookiePolicyLink = <Link color="inherit" href={cookiePolicyUrl} className={this.props.classes.bannerTextLink} rel="noopener noreferrer" target="_blank">Cookie Notice</Link>;

    let topMessage = <span className={this.props.classes.bannerText} >{brandName} is now part of Versant. By continuing to use this service, you agree to our Terms. You also acknowledge that our updated Privacy Policy applies, including to your existing data. For details on your data rights, {dataRightsLink}</span>
    let bottomMessage = <span className={this.props.classes.bannerText} >We and our partners also use tools on this site to provide the services, personalize your experience, and for analytics, marketing, and advertising. If you continue to use this site, you agree that your data may be collected, used, and shared for these purposes as set forth in our {privacyPolicyLink} and {cookiePolicyLink}.</span>

    let banner = (
      <Grid className={this.props.classes.banner} container spacing={1} justifyContent="center" >
        <Grid item xs={10} md={8} lg={6}>
          <Typography className={this.props.classes.bannerText} align="left">
            {topMessage}
          </Typography>
          <Typography className={this.props.classes.bannerText} align="left">
            {bottomMessage}
          </Typography>
        </Grid>
        <Grid item xs={10} md={2} lg={2} className={this.props.classes.bannerDismissButton}>
          <Button className={this.props.classes.button} color="secondary" onClick={this.props.onDismissPrivacyBanner} variant="contained" id="createAccount">
            Continue
          </Button>
        </Grid>
      </Grid >
    );


    return banner;
  }
}

export default withStyles(styles)(PrivacyBanner);